import type { PgProduct } from '@/shared/types';

/**
 * getProducts() can return multiple rows per product id (one fragment of `indicators` each).
 * Merge those rows into a single PgProduct with a combined `indicators` map.
 */
function mergeIndicatorFragments(rows: PgProduct[]): PgProduct {
  if (rows.length === 1) return rows[0];
  const base = { ...rows[0] };
  const indicators: Record<string, string[]> = {};
  for (const r of rows) {
    if (!r.indicators || typeof r.indicators !== 'object') continue;
    for (const [k, raw] of Object.entries(r.indicators)) {
      const arr = Array.isArray(raw) ? raw.map(String) : [String(raw)];
      const prev = indicators[k];
      if (!prev) {
        indicators[k] = [...arr];
      } else {
        const s = new Set([...prev, ...arr]);
        indicators[k] = Array.from(s).sort();
      }
    }
  }
  return { ...base, indicators };
}

/** Merge all rows that share `id` into one product (for tutorial / single-id fetch). */
export function mergePgProductRowsForId(products: PgProduct[], id: number): PgProduct | null {
  const rows = products.filter((p) => p.id === id);
  if (rows.length === 0) return null;
  return mergeIndicatorFragments(rows);
}
